export const env = {
  apiUrl: window.apiUrl,
  iconBaseUrl: window.iconBaseUrl
};

export const RECAPTCHA_SITE_KEY = window.RECAPTCHA_SITE_KEY;
